<div class="deal-detail-page">
  @if (loading) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  <a class="back-button" routerLink="/commissions">
    <mat-icon>arrow_back_ios_new</mat-icon>
    {{ 'prequalify-actions.component.back_button' | localise: 'Back' }}
  </a>
  <mat-divider class="m-t-24"></mat-divider>
  <h3>
    {{
      'dashboard-commission-details.component.commission_header'
        | localise: 'Commission'
    }}
  </h3>
  <ul>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.property_address'
            | localise: 'Property Address'
        }}
      </h4>
      <p>{{ deal | fullAddress }}</p>
    </li>
    <li>
      <h4>
        {{ 'dashboard-commission-details.component.mls' | localise: 'MLS' }}#
      </h4>
      <p>{{ deal?.mls }}</p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.commission_amount'
            | localise: 'Your Net Commission'
        }}
      </h4>
      <p>
        {{ deal?.agentCommissionAmount | currencyJs: { showSymbol: true } }}
      </p>
    </li>
    <li>
      <h4>
        {{
          'deal-details.component.expected_closing_date'
            | localise: 'Expected Closing Date'
        }}
      </h4>
      <p>
        {{ deal?.closingDate | dateApp: formatDateEnum.MMMDDYYYY }}
      </p>
    </li>
    <li>
      <h4>
        {{ 'deal-details.component.selling_agent' | localise: 'Selling Agent' }}
      </h4>
      <p>{{ this.authenticationService.getProfileState().fullName }}</p>
    </li>
    <li>
      <h4>
        {{
          'advance-application-completed.component.contract_of_sale_header'
            | localise: 'Contract of Sale'
        }}
      </h4>
      @if (
        deal?.userDealDocuments
          | getDocumentByType: userDealDocumentDocumentTypeEnum.ContractOfSale;
        as contractOfSale
      ) {
        @if (loadingFile) {
          <mat-spinner [diameter]="22"></mat-spinner>
        }
        @if (!loadingFile) {
          <p>
            <app-preview-document
              [documentName]="contractOfSale.s3Key | fileName"
              [isRemovable]="deal?.status === dealStatusEnum.Requested"
              [fileName]="contractOfSale.s3Key"
              (remove)="removeDocument($event)"
              [documentId]="contractOfSale.id">
              <a href="javascript:void(0)" class="tongo-link">
                {{
                  'deal-details.component.view_contract_link'
                    | localise: 'View Contract'
                }}
              </a>
            </app-preview-document>
          </p>
        }
      } @else {
        <p>
          @if (loadingFile) {
            <mat-spinner [diameter]="22"></mat-spinner>
          }
          <label
            class="upload-button p-button p-button--rounded p-button--apply-now-header"
            [class.hidden]="loadingFile">
            {{
              'deal-details.component.upload_contract'
                | localise: 'Upload Contract'
            }}
            <input
              type="file"
              accept=".pdf,.doc,.docx,.dot,.dotx,.docm,.dotm"
              ngFileSelect
              [options]="options"
              (uploadOutput)="onUploadOutput($event)"
              [uploadInput]="uploadInput" />
          </label>
        </p>
      }
    </li>
  </ul>

  @if (
    !!transactionList?.total && !!promisedPayment?.id && (deal | isStatement)
  ) {
    <button
      class="btn"
      mat-button
      (click)="downloadStatement(promisedPayment!.id)">
      {{
        'deal-details.component.download_statement_link'
          | localise: 'Download Statement'
      }}
    </button>
  }

  <mat-divider></mat-divider>
  <!-- Advance section -->
  <h3>
    {{ 'dashboard-commission-details.component.cloc' | localise: 'Advance' }}
  </h3>
  <ul>
    <li>
      <h4>
        {{
          'deal-details.component.date_requested' | localise: 'Date Requested'
        }}
      </h4>
      <p>
        {{ deal?.createdAt | dateApp: formatDateEnum.MMMDDYYYY }}
      </p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.approved_limit'
            | localise: 'Approved Limit'
        }}
      </h4>
      <p>
        {{ deal?.approvedLimitAmount | currencyJs: { showSymbol: true } }}
      </p>
    </li>

    <li>
      <h4>
        {{
          'dashboard-commission-details.component.amount_used'
            | localise: 'Amount Used'
        }}
      </h4>
      <p>
        {{ balance?.unpaidPrincipal | currencyJs: { showSymbol: true } }}
      </p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.amount_remaining'
            | localise: 'Amount Remaining'
        }}
      </h4>
      @if (deal && balance?.unpaidPrincipal) {
        <p>
          {{
            deal.approvedLimitAmount.subtract(balance.unpaidPrincipal)
              | currencyJs: { showSymbol: true }
          }}
        </p>
      } @else {
        <p>
          {{ deal?.approvedLimitAmount | currencyJs: { showSymbol: true } }}
        </p>
      }
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.total_fees'
            | localise: 'Total Fees'
        }}
      </h4>
      <p>
        {{ balance?.unpaidFees | currencyJs: { showSymbol: true } }}
      </p>
    </li>
    <li>
      <h4>
        {{
          'dashboard-commission-details.component.balance_owed'
            | localise: 'Balance Owed'
        }}
      </h4>
      @if (balance) {
        <p>
          {{
            balance.unpaidFees.add(balance.unpaidPrincipal)
              | currencyJs: { showSymbol: true }
          }}
        </p>
      } @else {
        <p>$0.00</p>
      }
    </li>
  </ul>

  <div class="alert">
    {{
      'deal-details.component.please_contact_support'
        | localise
          : 'If you need additional support regarding this deal, please contact support by emailing'
    }}
    <a href="mailto:support@gettongo.com">{{
      'deal-details.component.support_gettongo_com_link'
        | localise: 'support@gettongo.com'
    }}</a>
    {{
      'deal-details.component.support_calling'
        | localise: 'or calling (929) 456-5396'
    }}.
  </div>
  <div>
    @if (
      deal?.status === dealStatusEnum.Approved &&
      !(user | async)?.inExternalCollectionAt
    ) {
      <button
        mat-button
        class="btn"
        (click)="openMakeChanges(updateClosingDateTmp)">
        <span>{{
          'deal-details.component.change_closing_date_link'
            | localise: 'Change Closing Date'
        }}</span>
      </button>
    }
  </div>

  <mat-divider></mat-divider>
</div>

<ng-template #updateClosingDateTmp>
  <div class="close-dialog-holder">
    <button
      mat-icon-button
      mat-dialog-close
      type="button"
      class="close-dialog-button">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <form [formGroup]="promisedPaymentForm" (ngSubmit)="updateDealClosingDate()">
    <mat-dialog-content>
      @if (promisedPayment) {
        <p class="closing-date-description">
          {{
            'deal-details.component.adjust_closing_date_or_set_new_payment_date'
              | localise
                : 'Adjust your closing date or set a new payment date here. The amount you owe may change with the dates.'
          }}
        </p>
        <p>
          <strong>
            {{
              (promisedPaymentPreview | totalByPromisedList) ||
                promisedPayment.total | currencyJs: { showSymbol: true }
            }}
            {{ 'deal-details.component.amount_due' | localise: 'due' }}
          </strong>
        </p>
      }

      @if (promisedPaymentPreview) {
        <mat-divider></mat-divider>
        <p>
          <strong>{{
            'deal-details.component.you_should_pay'
              | localise: 'You should pay:'
          }}</strong>
        </p>
        @for (payment of promisedPaymentPreview; track payment) {
          <p>
            {{
              payment.effectiveDate | dateApp: formatDateEnum.MMDDYYYY : true
            }}:
            {{ payment.total | currencyJs: { showSymbol: true } }}
          </p>
        }
      }

      @if (promisedPayment) {
        <mat-divider></mat-divider>
      }
      <div class="dates__closing">
        <h3>
          {{
            'deal-details.component.payment_closing_date'
              | localise: 'Closing Date'
          }}
        </h3>
        <mat-calendar
          [minDate]="closingDateMin"
          [selected]="promisedPaymentForm.get('closingDate')?.value"
          (selectedChange)="
            promisedPaymentForm.get('closingDate')?.setValue($event)
          ">
        </mat-calendar>
      </div>

      @if (
        promisedPaymentForm.controls.closingDate.value
          | isMoreDays: deal?.closingDate : maxDiffClosingDate
      ) {
        <div class="upload-document">
          @if (!promisedPaymentForm.controls.userDealDocumentId.value) {
            <p class="addendum-doc-explain">
              {{
                'deal-details.component.upload_extension_or_addendum_for_listing'
                  | localise
                    : 'Please upload the extension/addendum for this listing'
              }}
            </p>
            <mat-form-field appearance="fill">
              <mat-label>{{
                'deal-details.component.payment_description'
                  | localise: 'Description'
              }}</mat-label>
              <textarea
                matInput
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="descriptionForClosingDate"></textarea>
            </mat-form-field>
            @if (loadingFile) {
              <mat-spinner [diameter]="22"></mat-spinner>
            }
            <label
              class="upload-button p-button p-button--rounded p-button--apply-now-header"
              [class.hidden]="loadingFile">
              {{
                'deal-details.component.payment_upload_document'
                  | localise: 'Upload Document'
              }}
              <input
                type="file"
                accept=".pdf,.doc,.docx,.dot,.dotx,.docm,.dotm"
                ngFileSelect
                [options]="options"
                (uploadOutput)="
                  onUploadOutput(
                    $event,
                    userDealDocumentDocumentTypeEnum.ExpansionAddendum,
                    descriptionForClosingDate
                  )
                "
                [uploadInput]="uploadInput" />
            </label>
          } @else {
            <span class="document-is-uploaded">
              {{
                'deal-details.component.payment_document_uploaded'
                  | localise: 'Document is uploaded'
              }}
              <mat-icon class="material-icons-outlined" color="accent"
                >check_circle</mat-icon
              >
            </span>
          }
        </div>
      }

      @if (error) {
        @switch (error) {
          @case ('Only one closing date change is allowed') {
            <p
              class="p-error-message p-error-message--margin only-one-closing-date-change">
              {{
                'deal-details.component.one_closing_date_change_is_allowed'
                  | localise: 'Only one closing date change is allowed.'
              }}<br />
              {{
                'deal-details.component.to_change_closing_date_contact'
                  | localise
                    : 'If you need to change the closing date, please contact'
              }}
              <a href="mailto:{{ sharedService.companyEmail }}">{{
                sharedService.companyEmail
              }}</a>
              {{
                'deal-details.component.to_change_closing_date_call'
                  | localise: 'or call'
              }}
              <a href="tel:{{ sharedService.companyPhone }}">{{
                sharedService.companyPhoneFormatted
              }}</a>
            </p>
          }
          @default {
            <p
              class="p-error-message p-error-message--margin only-one-closing-date-change">
              {{ error }}
            </p>
          }
        }
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close class="dialog-button" type="button">
        {{ 'deal-details.component.cancel_button' | localise: 'Cancel' }}
      </button>
      <button
        mat-button
        cdkFocusInitial
        class="dialog-button dialog-button--primary"
        type="submit">
        {{ 'deal-details.component.update_button' | localise: 'Update' }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #dealMakeChangesTmp>
  <div class="close-dialog-holder">
    <button
      mat-icon-button
      mat-dialog-close
      type="button"
      class="close-dialog-button">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <form [formGroup]="promisedPaymentForm" (ngSubmit)="updateDealPaymentDate()">
    <mat-dialog-content>
      @if (promisedPayment) {
        <p>
          {{
            'deal-details.component.promised_payment_adjust_closing_date_or_set_new_payment'
              | localise
                : 'Adjust your closing date or set a new payment date here. The amount you owe may change with the dates.'
          }}
        </p>
        <p>
          <strong>
            {{
              (promisedPaymentPreview | totalByPromisedList) ||
                promisedPayment.total | currencyJs: { showSymbol: true }
            }}
            {{ 'deal-details.component.amount_due' | localise: 'due' }}
          </strong>
        </p>
      }

      @if (promisedPaymentPreview) {
        <mat-divider></mat-divider>
        <p>
          <strong>{{
            'deal-details.component.you_should_pay'
              | localise: 'You should pay:'
          }}</strong>
        </p>
        @for (payment of promisedPaymentPreview; track payment) {
          <p>
            {{
              payment.effectiveDate | dateApp: formatDateEnum.MMDDYYYY : true
            }}:
            {{ payment.total | currencyJs: { showSymbol: true } }}
          </p>
        }
      }

      @if (promisedPayment) {
        <mat-divider></mat-divider>
      }
      @if (!promisedPayment) {
        <div class="dates__closing">
          <h3>
            {{
              'deal-details.component.payment_date' | localise: 'Payment Date'
            }}
          </h3>
          <mat-calendar
            [minDate]="paymentDateMin"
            [selected]="promisedPaymentForm.get('paymentDate')?.value"
            (selectedChange)="
              promisedPaymentForm.get('paymentDate')?.setValue($event)
            ">
            <mat-calendar-header>{{
              'deal-details.component.payment_date' | localise: 'Payment Date'
            }}</mat-calendar-header>
          </mat-calendar>
        </div>
      }
      @if (promisedPayment) {
        <div class="dates-holder">
          <!--        <div class="dates__closing">-->
          <!--          <h3>Closing Date</h3>-->
          <!--          <mat-calendar [selected]="promisedPaymentForm.get('closingDate')?.value"-->
          <!--                        (selectedChange)="promisedPaymentForm.get('closingDate')?.setValue($event); updatedClosingDate()">-->
          <!--            <mat-calendar-header>Closing Date</mat-calendar-header>-->
          <!--          </mat-calendar>-->
          <!--        </div>-->
          @if (promisedPayment) {
            <div class="dates__repayment">
              <h3>
                {{
                  'deal-details.component.expected_repayment_date'
                    | localise: 'Expected Repayment Date'
                }}
              </h3>
              <mat-calendar
                [minDate]="paymentDateMin"
                [selected]="promisedPaymentForm.get('paymentDate')?.value"
                (selectedChange)="
                  promisedPaymentForm.get('paymentDate')?.setValue($event)
                ">
              </mat-calendar>
            </div>
          }
        </div>
      }
      <!--    <app-day-input floatLabel="always"-->
      <!--                   label="Closing Date"></app-day-input>-->
      <!--    <app-day-input floatLabel="always"-->
      <!--                   label="Repayment Date"></app-day-input>-->
      @if (promisedPayment) {
        <mat-divider></mat-divider>
        <h3>
          {{
            'deal-details.component.bank_account_to_pay_from'
              | localise: 'Choose a Bank Account to pay from'
          }}
        </h3>
        <div>
          <mat-form-field>
            <mat-select
              [panelClass]="themesService.getDarkThemeClass()"
              formControlName="bankAccountId">
              @for (item of bankList; track item) {
                <mat-option [value]="item.id">
                  {{
                    'deal-details.component.account_number'
                      | localise: 'Account # '
                  }}
                  {{ item.accountNumber }}
                  {{
                    'deal-details.component.account_number_at'
                      | localise: ' at '
                  }}
                  {{ item.institution }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{
              'deal-details.component.promised_payment_type' | localise: 'Type'
            }}</mat-label>
            <mat-select formControlName="type">
              @for (item of promisedPaymentTypes; track item) {
                <mat-option [value]="item.value">{{ item.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (error) {
        @switch (error) {
          @case ('Only one closing date change is allowed') {
            <p
              class="p-error-message p-error-message--margin only-one-closing-date-change">
              {{
                'deal-details.component.one_closing_date_change_is_allowed'
                  | localise: 'Only one closing date change is allowed.'
              }}<br />
              {{
                'deal-details.component.to_change_closing_date_contact'
                  | localise
                    : 'If you need to change the closing date, please contact'
              }}
              <a href="mailto:{{ sharedService.companyEmail }}">{{
                sharedService.companyEmail
              }}</a>
              {{
                'deal-details.component.to_change_closing_date_call'
                  | localise: 'or call'
              }}
              <a href="tel:{{ sharedService.companyPhone }}">{{
                sharedService.companyPhoneFormatted
              }}</a>
            </p>
          }
          @default {
            <p
              class="p-error-message p-error-message--margin only-one-closing-date-change">
              {{ error }}
            </p>
          }
        }
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close class="dialog-button" type="button">
        {{ 'deal-details.component.cancel_button' | localise: 'Cancel' }}
      </button>
      <button
        mat-button
        cdkFocusInitial
        class="dialog-button dialog-button--primary"
        type="submit">
        {{ 'deal-details.component.update_button' | localise: 'Update' }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #transactionTable>
  <h3>
    {{
      'deal-details.component.transactions_for' | localise: 'Transactions for '
    }}{{ deal | fullAddress }}
  </h3>
  <table mat-table [dataSource]="transactionList.list">
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'deal-details.component.transactions_date' | localise: 'Date' }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.transaction.date | dateApp: formatDateEnum.MMMDD }}
      </td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'deal-details.component.transactions_amount' | localise: 'Amount' }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.transaction.amount | currencyJs: { showSymbol: true } }}
      </td>
    </ng-container>
    <ng-container matColumnDef="unpaidAmount">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'deal-details.component.transactions_unpaid_amount'
            | localise: 'Unpaid Amount'
        }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.transaction.unpaidAmount | currencyJs: { showSymbol: true } }}
      </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'deal-details.component.transactions_type' | localise: 'Type' }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ transactionTypeNames[app.transaction.type] }}
      </td>
    </ng-container>
    <ng-container matColumnDef="method">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'deal-details.component.transactions_method' | localise: 'Method' }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ transactionMethodNames[app.transaction.method] }}
      </td>
    </ng-container>
    <ng-container matColumnDef="externalService">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'deal-details.component.transactions_external_service'
            | localise: 'External Service'
        }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ transactionExternalServiceNames[app.transaction.externalService] }}
      </td>
    </ng-container>
    <ng-container matColumnDef="creditCardNumber">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'deal-details.component.transactions_credit_card'
            | localise: 'Credit Card'
        }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.transaction.creditCard?.cardNumberMask || '-' }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsTransaction"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsTransaction"></tr>
  </table>
</ng-template>
